import React, { Component } from "react";
import Identicon from "identicon.js";
import crypto from "crypto";

export interface UserAvatarProps {
    size: number;
    email: string;
    title?: string;
}

const makeChars = length => {
    var result = "";
    var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        );
    }
    return result;
};

class UserAvatar extends Component<UserAvatarProps, {}> {
    private avatarImgRef;

    constructor(props) {
        super(props);
        this.avatarImgRef = React.createRef();
    }

    componentDidMount() {
        this.updateAvatar();
    }

    componentDidUpdate() {
        this.updateAvatar();
    }

    updateAvatar() {
        const data = new Identicon(
            this.props.email.length < 15
                ? `this.props.email${makeChars(15 - this.props.email.length)}`
                : this.props.email,
            {
                background: [255, 255, 255, 255],
                foreground: [234, 34, 72, 255],
                margin: 0.2,
                size: this.props.size
            }
        ).toString();
        this.avatarImgRef.current.src = "data:image/png;base64, " + data;
    }

    render() {
        return this.props.email ? (
            <img
                ref={this.avatarImgRef}
                width={this.props.size.toString() + "px"}
                height={this.props.size.toString() + "px"}
                className="avatar-img"
                title={this.props.title}
                src=""
            />
        ) : null;
    }
}

export default UserAvatar;
